// Generated by `bazel run i18n`. Do not edit by hand.
import flow_28072806 from "./en/src--flow.json";
import chooseCompensationMethod_08dd9b0f from "./en/src--hooks--chooseCompensationMethod.json";
import useCommonChooseCompensation_afc1e646 from "./en/src--hooks--shared-hooks--use-common-choose-compensation.json";
import useFlowAiReturnReasons_0f3604b9 from "./en/src--hooks--use-flow-ai-return-reasons.json";
import useFlowInput_efa50b4e from "./en/src--hooks--use-flow-input.json";
import useFlowReject_926ab87e from "./en/src--hooks--use-flow-reject.json";
import useFlowReturn_e70830f5 from "./en/src--hooks--use-flow-return.json";
import useRecommendedProductExchange_996d5761 from "./en/src--hooks--use-recommended-product-exchange.json";
import useVariantExchange_aa4d92eb from "./en/src--hooks--use-variant-exchange.json";
import useVariantPicker_c742dc94 from "./en/src--hooks--use-variant-picker.json";
import useAddress_546e6b85 from "./en/src--hooks--useAddress.json";
import useCarrierOptions_4c0524c7 from "./en/src--hooks--useCarrierOptions.json";
import useCart_f0c658ec from "./en/src--hooks--useCart.json";
import useEditAddress_65d1aa2a from "./en/src--hooks--useEditAddress.json";
import useFlow_b59f97a7 from "./en/src--hooks--useFlow.json";
import useItemDetails_ea26522e from "./en/src--hooks--useItemDetails.json";
import useMerchantFlow_477ac110 from "./en/src--hooks--useMerchantFlow.json";
import usePackagePickup_d4f01a10 from "./en/src--hooks--usePackagePickup.json";
import usePackagePickupUpsell_5a2a3f52 from "./en/src--hooks--usePackagePickupUpsell.json";
import useProvisionSelection_c7b290e5 from "./en/src--hooks--useProvisionSelection.json";
import useRefundDestination_46b617fb from "./en/src--hooks--useRefundDestination.json";
import useReturnConfirmation_b24d6a70 from "./en/src--hooks--useReturnConfirmation.json";
import useReview_24bce8f1 from "./en/src--hooks--useReview.json";
import useSelectItems_4c6b14c8 from "./en/src--hooks--useSelectItems.json";
import useShipmentMethod_155fd866 from "./en/src--hooks--useShipmentMethod.json";
import useShopNow_aae5c757 from "./en/src--hooks--useShopNow.json";
import useShopOnSite_3a535140 from "./en/src--hooks--useShopOnSite.json";
import utils_bae51d68 from "./en/src--utils.json";
import src_c1a2d0b5 from "./en/src.json";

export default Object.assign(
  {},
  flow_28072806,
  chooseCompensationMethod_08dd9b0f,
  useCommonChooseCompensation_afc1e646,
  useFlowAiReturnReasons_0f3604b9,
  useFlowInput_efa50b4e,
  useFlowReject_926ab87e,
  useFlowReturn_e70830f5,
  useRecommendedProductExchange_996d5761,
  useVariantExchange_aa4d92eb,
  useVariantPicker_c742dc94,
  useAddress_546e6b85,
  useCarrierOptions_4c0524c7,
  useCart_f0c658ec,
  useEditAddress_65d1aa2a,
  useFlow_b59f97a7,
  useItemDetails_ea26522e,
  useMerchantFlow_477ac110,
  usePackagePickup_d4f01a10,
  usePackagePickupUpsell_5a2a3f52,
  useProvisionSelection_c7b290e5,
  useRefundDestination_46b617fb,
  useReturnConfirmation_b24d6a70,
  useReview_24bce8f1,
  useSelectItems_4c6b14c8,
  useShipmentMethod_155fd866,
  useShopNow_aae5c757,
  useShopOnSite_3a535140,
  utils_bae51d68,
  src_c1a2d0b5,
);
